// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const iron_treads: PokeData = {
  "id": 990,
  "name": "iron-treads",
  "height": 9,
  "weight": 2400,
  "base_experience": 285,
  "types": [
    PokeType.GROUND,
    PokeType.STEEL
  ],
  "api_moves": [
    "horn-attack",
    "earthquake",
    "defense-curl",
    "rollout",
    "megahorn",
    "rapid-spin",
    "knock-off",
    "endeavor",
    "giga-impact",
    "iron-head",
    "heavy-slam",
    "bulldoze",
    "wild-charge",
    "electric-terrain",
    "stomping-tantrum",
    "steel-roller"
  ],
  "moves": [
    "earthquake",
    "wild-charge",
    "electric-terrain",
    "iron-defense",
    "smart-strike",
    "scrap-throw",
    "metal-claw",
    "mud-bomb",
    "behemoth-bash",
    "bonemerang",
    "bone-throw",
    "mud-shot",
    "steel-beam"
  ],
  "evolution_chain": {
    "id": 521,
    "item": null,
    "species": [
      {
        "name": "iron-treads",
        "order": 986,
        "types": [
          PokeType.GROUND,
          PokeType.STEEL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 119,
    "speed": 137,
    "ability_power": 144
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
